import { render, staticRenderFns } from "./Box12.vue?vue&type=template&id=a2a36b92&scoped=true&"
import script from "./Box12.vue?vue&type=script&lang=js&"
export * from "./Box12.vue?vue&type=script&lang=js&"
import style0 from "./Box12.vue?vue&type=style&index=0&id=a2a36b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a36b92",
  null
  
)

export default component.exports